import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "faq-unit" }
const _hoisted_2 = {
  key: 0,
  class: "faq-unit__text-box"
}
const _hoisted_3 = { class: "faq-unit__text" }

import { ref } from 'vue'
import type { RendererElement } from 'vue'
import { Mixpanel } from '@/analytics/mixpanel'

/**
 * @param title the title of the FAQ – will be clicked to expand its contents
 * @param type the type this FAQ item belongs to – used for mixpanel tracking
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'FAQUnit',
  props: {
    title: {},
    type: {}
  },
  setup(__props: any) {

const props = __props

const collapsed = ref(true)

function toggleCollapsible(): void {
  collapsed.value = !collapsed.value

  // Only track when FAQ item is expanded
  if (collapsed.value === false) {
    Mixpanel.trackFAQItemView(props.type, props.title)
  }
}

function start(el: RendererElement): void {
  el.style.height = '0px'
  el.style.height = el.scrollHeight + 'px'
}

function end(el: RendererElement): void {
  el.style.height = el.scrollHeight + 'px'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["faq-unit__title", { 'faq-unit__title--open': !collapsed.value }]),
      onClick: toggleCollapsible
    }, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "faq-unit__icon-wrapper" }, [
        _createElementVNode("span", { class: "faq-unit__icon iconfont ifaq" })
      ], -1))
    ], 2),
    _createVNode(_Transition, {
      name: "faq-unit__transition",
      onEnter: start,
      onAfterEnter: end,
      onBeforeLeave: start,
      onAfterLeave: end
    }, {
      default: _withCtx(() => [
        (!collapsed.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})